import { FC, HTMLAttributes } from "react";

import { FeedbackCreation, ReportFeedback } from "../../../../types/ReportTypes";
import { Feedback } from "./Feedback";

export const getSectionFeedback = (sectionIdentifier: string, feedback?: ReportFeedback[]) => {
    return feedback?.find((f) => f.sectionIdentifier === sectionIdentifier);
};

interface SectionFeedbackProps extends HTMLAttributes<HTMLDivElement> {
    feedback?: ReportFeedback[];
    sectionIdentifier: string;
    sectionName: string;
    onFeedbackAdd?: (feedback: FeedbackCreation) => Promise<void>;
    onFeedbackRemove?: (feedbackId?: number) => Promise<void>;
}

export const SectionFeedback: FC<SectionFeedbackProps> = ({
    feedback,
    sectionIdentifier,
    sectionName,
    onFeedbackAdd,
    onFeedbackRemove,
    ...props
}) => {
    const sectionFeedback = getSectionFeedback(sectionIdentifier, feedback);
    return (
        <Feedback
            {...props}
            like={sectionFeedback?.isPositive}
            onFeedbackAdd={async (data) =>
                onFeedbackAdd?.({
                    ...data,
                    sectionIdentifier,
                    metadata: { sectionName },
                })
            }
            onFeedbackRemove={async () => onFeedbackRemove?.(sectionFeedback?.id)}
        />
    );
};
